import { RouteLocationNormalized } from 'vue-router';
import { EventAggregationService } from '@/platform/EventAggregationService';
import { IEmbeddedState } from './IEmbeddedState';
import { EmbeddedStatePropagation } from './EmbeddedStatePropagation';
import { EmbeddedStateFactory } from './EmbeddedStateFactory';
import { EmbeddedStatePropagationInitiatedEvent } from './events/EmbeddedStatePropagationInitiatedEvent';

export class UrlEmbeddedStatePropagation {
	private readonly eventAggregationService: EventAggregationService;
	private readonly embeddedState: EmbeddedStateFactory;

	public constructor(eventAggregationService: EventAggregationService, embeddedState: EmbeddedStateFactory) {
		this.eventAggregationService = eventAggregationService;
		this.embeddedState = embeddedState;
	}

	public begin(state: IEmbeddedState): Promise<void> {
		const embeddedStatePropagation = new EmbeddedStatePropagation(this.eventAggregationService, state, false);
		embeddedStatePropagation.begin();

		return Promise.resolve();
	}

	public async beginFrom(destination: RouteLocationNormalized, isInitial: boolean): Promise<void> {
		const propagatePromise = this.propagateFrom(destination, isInitial);

		this.eventAggregationService.publish(new EmbeddedStatePropagationInitiatedEvent(propagatePromise, destination));

		await propagatePromise;
	}

	private async propagateFrom(destination: RouteLocationNormalized, isInitial: boolean): Promise<void> {
		const embeddedStateFromNavigation = await this.embeddedState.fromNavigationDestination(destination);

		let embeddedStateTarget: IEmbeddedState;
		if (isInitial) {
			embeddedStateTarget = this.embeddedState.fromCommitted().toMutable().mergeWith(embeddedStateFromNavigation);
		} else {
			embeddedStateTarget = embeddedStateFromNavigation;
		}

		const embeddedStatePropagation = new EmbeddedStatePropagation(
			this.eventAggregationService,
			embeddedStateTarget,
			isInitial
		);
		embeddedStatePropagation.begin();
	}
}
